<template>
  <div>
    <label
      v-if="labelText !== ''"
      class="mb-1.5 block text-sm font-medium text-primary"
    >
      {{ labelText }}
    </label>
    <div class="relative">
      <div class="absolute -translate-y-1/2 left-3 top-1/2 text-slate-600">
        <slot name="icon" />
      </div>
      <input
        :type="inputType"
        :value="val"
        :class="`text-md border-1 focus:shadow-outline block w-full rounded-sm border-gray-300 bg-white pl-10 leading-tight text-primary placeholder-slate-300 shadow-sm focus:border-main-primary focus:ring-main-primary ${classes}  py-2.5`"
        :placeholder="placeholder"
        :disabled="disabled"
        :required="required"
        @input="$emit('input', $event.target.value)"
      >
    </div>
    <small
      v-if="errorMessage"
      class="block mt-2 text-red-primary"
    >{{
      errorMessage
    }}</small>
  </div>
</template>

<script>
export default {
  name: 'InputWithIcon',

  props: {
    val: {
      type: [String, Number],
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    inputType: {
      type: String,
      default: 'text',
    },
    labelText: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    classes: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['input'],

  data() {
    return {
      errorMessage: this.error,
      inputIsDisabled: this.disabled,
    }
  },

  watch: {
    error(newErrorMessage) {
      this.errorMessage = newErrorMessage
    },
    disabled(isDisabled) {
      this.inputIsDisabled = isDisabled
    },
  },
}
</script>
